<template>
  <div id="platform"
       class="PlatformView view"
  >
    <TheHeader :user="user" />
    <div class="PlatformView__pages">
      <div class="PlatformView__content">
        <div style="margin-top: 15px; padding: 0 25px">
          <ShDividerLine />
        </div>
        <transition name="fade">
          <router-view />
        </transition>
        <TheFooter />
      </div>
    </div>
    <ShSideBarModal
      :title="`Profil użytkownika: ${
        editableUser ? newUserFullName : ''
      }`"
      description="Poniżej znajdują się dane użytkownika"
      :width="800"
      :side-bar-modal-visibility.sync="isUserModalVisible"
    >
      <template v-slot:content>
        <UserProfile
          :user="editableUser"
          :should-refresh-list="shouldRefreshUsersList"
          @closeModal="isUserModalVisible = false"
        />
      </template>
    </ShSideBarModal>
    <ShSideBarModal
      title="Przypisywanie użytkownika do aplikacji callweb"
      description="Wybierz profil użytkownika i aktywuj do w aplikacji callweb"
      :side-bar-modal-visibility.sync="isAddInactiveUserModalVisible"
    >
      <template v-slot:content>
        <AddInactiveUserToCallwebForm
          :user="editableUser"
          @closeModal="isAddInactiveUserModalVisible = false"
        />
      </template>
    </ShSideBarModal>
    <ShSideBarModal
      title="Napisz do nas"
      :wrapper-closable="false"
      :side-bar-modal-visibility.sync="isContactFormModalVisible"
      :width="600"
    >
      <template v-slot:content>
        <ContactForm
          @handleCloseModalWindow="isContactFormModalVisible = false"
        />
      </template>
    </ShSideBarModal>
    <ShModalWindow
      v-if="shouldShowaAllertAboutExpiredAccess && isAccessExpired"
      @closeModal="
        shouldShowaAllertAboutExpiredAccess =
          !shouldShowaAllertAboutExpiredAccess
      "
    >
      <template #header>
        <img
          style="margin-right: 10px"
          :src="require('@/assets/images/ikona-blokada-konta.png')"
        >
        Konto zostało zablokowane
      </template>
      <template #description>
        <PopupHints hint-template-name="expiredAccess" />
      </template>
    </ShModalWindow>
    <ShopWithAvailablePackages v-if="isShopWithPackagesVisible" />
    <el-backtop v-if="!isMenuMobileOpen"
                target=".PlatformView__content"
    />
  </div>
</template>

<script>
import { hDeepCopy } from '@/utils/helpers';
import ShModalWindow from '@/components/Helpers/ShModalWindow';
import ShSideBarModal from '@/components/Helpers/ShSideBarModal';
import ShDividerLine from '@/components/Helpers/ShDividerLine';
import PopupHints from '@/components/Common/PopupHints';
import TheHeader from '@/components/Platform/TheHeader';
import TheFooter from '@/components/Platform/TheFooter';
import ContactForm from '@/components/ContactForm';
import UserProfile from '@/components/Users/UserProfile';
import AddInactiveUserToCallwebForm from '@/components/Users/AddInactiveUserToCallwebForm';
import ShopWithAvailablePackages from '@/components/Packages/ShopWithAvailablePackages';

export default {
  name: 'Platform',
  components: {
    TheHeader,
    TheFooter,
    PopupHints,
    UserProfile,
    ContactForm,
    ShModalWindow,
    ShDividerLine,
    ShSideBarModal,
    AddInactiveUserToCallwebForm,
    ShopWithAvailablePackages,
  },

  data() {
    return {
      editableUser: null,
      shouldRefreshUsersList: false,
      isUserModalVisible: false,
      isContactFormModalVisible: false,
      isAddInactiveUserModalVisible: false,
      shouldShowaAllertAboutExpiredAccess: true,
      isShopWithPackagesVisible: false,
    };
  },

  computed: {
    user() {
      return this.$store.getters['authorization/user'];
    },
    newUserFullName() {
      if (this.editableUser.last_name && this.editableUser.name) {
        return `${this.editableUser.name} ${this.editableUser.last_name}`;
      } if (this.editableUser.email) {
        return this.editableUser.email;
      }
      return '';
    },
    isAccessExpired() {
      return this.$store.getters['authorization/isAccessExpired'];
    },
    isMenuMobileOpen() {
      return this.$store.getters['app/isMenuExpanded'];
    },
  },

  async created() {
    await this.$store.dispatch('app/getGlobalDictionary');
    this.$store.dispatch('userProfiles/getList');
    this.$EventBus.$on('SHOW_USER_PROFILE', (data) => {
      this.shouldRefreshUsersList = data.shouldRefreshList;
      this.editableUser = hDeepCopy(data.user);
      this.isUserModalVisible = true;
    });
    this.$EventBus.$on('SHOW_CONTACT_FORM', () => {
      this.isContactFormModalVisible = true;
    });
    this.$EventBus.$on('TOGGLE_PACKAGE_SHOP', () => {
      this.isShopWithPackagesVisible = !this.isShopWithPackagesVisible;
    });
    this.$EventBus.$on(
      'AddInactiveUserToCallwebForm/SHOW_ADD_USER_TO_CALLWEB_FORM',
      (user) => {
        this.editableUser = user;
        this.isAddInactiveUserModalVisible = true;
      },
    );
  },

  async beforeRouteUpdate(to, from, next) {
    if (
      this.$store.getters['widgets/haveAnyChangesBeenDetected']
      && !this.$store.getters['widgets/isAnyAgentsOrDepartmentsHaveBeenAssigned']
    ) {
      try {
        await this.$confirm(
          `Wykryto niezapisane zmiany z błędną konfiguracją.
        Do widgetu nie został przypisany żaden Konsultant lub Wirtualny Dział. Czy chcesz poprawić konfigurację?`,
          'Uwaga!',
          {
            confirmButtonText: 'Tak, chcę poprawić',
            cancelButtonText: 'Anuluj',
            type: 'error',
          },
        );
        return;
      } catch (error) {
        this.$store.dispatch('widgets/cancelDetectedChanges');
        this.$notify.info({
          title: 'Konfiguracja widgetu',
          message: 'Zmiany zostały anulowane',
          customClass: 'callmeweb-notification',
        });
        next();
      }
    }

    if (this.$store.getters['widgets/haveAnyChangesBeenDetected']) {
      try {
        await this.$confirm(
          'Twoje zmiany nie zostały zapisane. Czy chcesz je zapisać przed wyjściem?',
          'Uwaga!',
          {
            confirmButtonText: 'Tak, zapisz zmiany',
            cancelButtonText: 'Anuluj',
            type: 'warning',
          },
        );
        const { id } = this.$route.params;
        await this.$store.dispatch('widgets/saveConfiguration', id);
        this.$notify.success({
          title: 'Konfiguracja widgetu',
          message: 'Zapisano konfigurację widgetu',
          customClass: 'callmeweb-notification',
        });
        next();
      } catch (error) {
        this.$store.dispatch('widgets/cancelDetectedChanges');
        this.$notify.info({
          title: 'Konfiguracja widgetu',
          message: 'Zmiany zostały anulowane',
          customClass: 'callmeweb-notification',
        });
        next();
      }
    }
    next();
  },

  beforeDestroy() {
    this.$EventBus.$off('SHOW_USER_PROFILE');
    this.$EventBus.$off('SHOW_CONTACT_FORM');
    this.$EventBus.$off('TOGGLE_PACKAGE_SHOP');
    this.$EventBus.$off(
      'AddInactiveUserToCallwebForm/SHOW_ADD_USER_TO_CALLWEB_FORM',
    );
  },
};
</script>

<style lang="sass">
.PlatformView
  display: flex
  flex: 1 1 auto
  flex-direction: column
  height: 100%
  min-height: 0

  &__pages
    display: flex
    flex: 1 1 auto
    flex-direction: column
    min-height: 0

  &__content
    display: flex
    flex: 1 1 auto
    flex-direction: column
    height: 0
    min-height: 0
    overflow-y: auto
    position: relative
</style>
